<template>
  <div>
    <div
      id="setting-container">
      <b-row>
        <b-col cols="12">
          <div v-if="board">
            <jBoardForm
              ref="refBoardForm"
              :board="board"
              mode="update"
              @getData="getBoardFormData"/>
            <b-button
              class="btn blue"
              @click="updateBoard">
              Update
            </b-button>
          </div>
        </b-col>

      </b-row>
      <br>

    </div>
  </div>
</template>

<script>
import jBoardForm from '@/views/board/form/jBoardForm';
import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardGeneralTab',
  components: {
    jBoardForm,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // boardId: null,
      searchQuery: '',
      boardForm: null,
      onUpdate: false,
    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board', 'boards_updated', 'form_detail']),
  },
  watch: {
    boardForm() {
      if (this.onUpdate) {
        if (this.boardForm !== null) {
          this.sendData();
        }
      }
    },
  },
  created() {
    // Get selected field list
    const params = {
      additional_info_block: {
        id: this.board.input_value,
      },
    };
    this.detailForm(params);
  },

  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoards', 'updateForm', 'detailForm', 'updateComponent', 'actionUpdateVisibilityPrivilege', 'actionUpdateEmailReminder']),

    updateBoard() {
      this.$refs.refBoardForm.validateForm();
    },

    getBoardFormData(data) {
      this.onUpdate = true;
      this.boardForm = data;
    },
    sendData() {
      this.updateForm(this.boardForm);
      this.onUpdate = false;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/board/tabs/jBoardGeneralTab.vue